import React, { useEffect, useState, useRef } from 'react';
import ScoreCard from '../UtilityComponents/ScoreCard';
import {
  Alert,
  Autocomplete,
  AutocompleteRenderInputParams,
  Box,
  Button,
  Chip,
  CircularProgress,
  ClickAwayListener,
  Drawer,
  Fade,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Modal,
  Paper,
  Popper,
  Portal,
  Radio,
  RadioGroup,
  Select,
  Slider,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
  abbreviateNumber,
  convertCurrency,
  getCountryDataFromCountryCode,
} from 'src/utils/functions';
import {
  COLOR_BACKGROUND_1,
  COLOR_GREY_200,
  COLOR_GREY_400,
  COLOR_GREY_600,
  COLOR_PRIMARY_1,
  COLOR_PRIMARY_2,
  COLOR_SUCCESS,
  COLOR_SUCCESS_1,
  COLOR_TEXT_1,
  COLOR_TEXT_4,
  COLOR_WARNING,
} from 'src/colors';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import CloseIcon from '@mui/icons-material/Close';
import { ContinuousSpinner } from 'src/App/Components/Loaders/ContinousSpinnerCard';
import {
  COLOR_E,
  COLOR_PRIMARY,
  exchangeRates,
  AVAILABLE_COUNTRY,
  SCALE_CTA,
  ALL_COUNTRY,
} from 'src/const';
import FilterListIcon from '@mui/icons-material/FilterList';
import DoneIcon from '@mui/icons-material/Done';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { getMinMaxActiveListingsAndPropertyPrice, getMinmaxROI } from '../helper';
import SearchIcon from '@mui/icons-material/Search';
import { CustomSwitch } from 'src/App/Components/Buttons';
import { MapActiveView } from 'src/interfaces/idashboard';

const DiscoveryTab = ({
  discoveryMarkets,
  setTopPerformingMarketOnFocus,
  marketsToCompareList,
  setMarketsToCompareList,
  setDashboardLayoutView,
  // minROI,
  // maxROI,
  isMarketDataAccessible,
  freeMarketDataKey,
  currency,
  mapWidth,
  setMapWidth,
  isDiscoveryMapViewOpen,
  setIsDiscoveryMapViewOpen,
  handleOnSampleClick,
  discoveryMarketType,
  setDiscoveryMarketType,
  allRawMarketData,
  discoverTabData,
  setDiscoveryTabData,
  selectedDiscoveryCountry,
  setSelectedDiscoveryCountry,
  isDiscoveryMarketLoading,
  setSelectedSidebarIndex,
  handleMarketSidebarClick,
  handleSidebarListItemClick,
  setAdvancedTab,
}: {
  discoveryMarkets: any[];
  setTopPerformingMarketOnFocus: any;
  marketsToCompareList: any[];
  setMarketsToCompareList: any;
  setDashboardLayoutView: any;
  // minROI: number;
  // maxROI: number;
  isMarketDataAccessible: boolean;
  freeMarketDataKey: string[];
  currency: string;
  mapWidth: number;
  setMapWidth: any;
  isDiscoveryMapViewOpen: boolean;
  setIsDiscoveryMapViewOpen: any;
  handleOnSampleClick: any;
  discoveryMarketType: any;
  setDiscoveryMarketType: any;
  allRawMarketData: any[];
  discoverTabData: any;
  setDiscoveryTabData;
  selectedDiscoveryCountry: string;
  setSelectedDiscoveryCountry: React.Dispatch<React.SetStateAction<string>>;
  isDiscoveryMarketLoading: boolean;
  setSelectedSidebarIndex: React.Dispatch<React.SetStateAction<number>>;
  handleMarketSidebarClick: any;
  handleSidebarListItemClick: any;
  setAdvancedTab: any;
}) => {
  const [active, setActive] = useState<MapActiveView>({
    map: true,
    list: false,
  });
  const [minActiveListingsCount, setMinActiveListingsCount] = useState(0);
  const [maxActiveListingCount, setMaxActiveListingCount] = useState(0);
  const [minPropertyPrice, setMinPropertyPrice] = useState(0);
  const [maxPropertyPrice, setMaxPropertyPrice] = useState(0);
  // const [discoverTabData, setDiscoveryTabData] = useState<any>([]);
  const [minROI, maxROI] = getMinmaxROI(discoverTabData);
  const [items, setItems] = useState<any>([]);
  const [activeListingFilterRange, setActiveListingFilterRange] = useState<[number, number]>([
    700,
    maxActiveListingCount,
  ]);
  const [propertyPriceFilterRange, setPropertyPriceFilterRange] = useState<[number, number]>([
    50000,
    500000,
  ]);
  const [hoveredMarket, setHoveredMarket] = useState(null);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);
  const [selectedMarketTypeFromFilter, setSelectedMarketTypeFromFilter] = useState<'top' | 'all'>(
    'all'
  );
  const [showCompareDrawer, setShowCompareDrawer] = useState<boolean>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(520));
  const matches = useMediaQuery(theme.breakpoints.down(900));
  const [filterAnchorEl, setFilterAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [
    marketIsNotAvaiiableAfterApplyingFilters,
    setMarketIsNotAvaiiableAfterApplyingFilters,
  ] = useState<boolean>(false);

  const redirectToAdvancedExplorerTab = () => {
    setAdvancedTab(0);
    handleMarketSidebarClick('advance');
    handleSidebarListItemClick(6);
  };

  useEffect(() => {
    if (active.list) {
      redirectToAdvancedExplorerTab();
    }
  }, [active]);

  useEffect(() => {
    if (matches && isDiscoveryMapViewOpen) {
      setMapWidth(100);
    }
  }, [matches]);

  useEffect(() => {
    const [minActive, maxActive, minPrice, maxPrice] = getMinMaxActiveListingsAndPropertyPrice(
      allRawMarketData
    );
    setMinActiveListingsCount(minActive);
    setMaxActiveListingCount(maxActive);
    setMinPropertyPrice(minPrice);
    setMaxPropertyPrice(maxPrice);
  }, [allRawMarketData]);

  useEffect(() => {
    if (items.length == 0) {
      setDiscoveryTabData(discoveryMarkets);
      setItems(discoveryMarkets.slice(0, 15));
    }

    if (isFilterApplied) {
      handleApplyFilter();
    }
  }, [discoveryMarkets]);

  useEffect(() => {
    if (discoveryMarketType == 'top') {
      resetFilterToDefault();
    }
  }, [discoveryMarketType, maxActiveListingCount]);

  useEffect(() => {
    if (marketsToCompareList.length == 1) {
      setShowCompareDrawer(true);
    }
  }, [marketsToCompareList]);

  useEffect(() => {
    isDiscoveryMarketLoading && setItems([]);
  }, [isDiscoveryMarketLoading]);

  useEffect(() => {
    setSelectedMarketTypeFromFilter('top');
    resetFilterToDefault();
    handleApplyFilter();
  }, [selectedDiscoveryCountry]);

  const fetchMoreData = () => {
    setTimeout(() => {
      setItems([...items, ...discoveryMarkets.slice(items.length, items.length + 15)]);
    }, 500);
  };

  const resetFilterToDefault = () => {
    setActiveListingFilterRange([700, maxActiveListingCount]);
    setPropertyPriceFilterRange([50000, 500000]);
  };

  const handleApplyFilter = () => {
    setDiscoveryMarketType(selectedMarketTypeFromFilter);
    let filteredData = discoveryMarkets;

    if (isMarketDataAccessible && discoveryMarketType != 'top') {
      filteredData = discoveryMarkets.filter(
        market =>
          market.total_supply >= activeListingFilterRange[0] &&
          market.total_supply <= activeListingFilterRange[1]
      );

      filteredData = filteredData.filter(
        market =>
          market.property_price >= propertyPriceFilterRange[0] &&
          market.property_price <= propertyPriceFilterRange[1]
      );
      filteredData = filteredData.sort((a, b) => b.ten_years_roi - a.ten_years_roi);

      if (filteredData.length == 0) {
        setMarketIsNotAvaiiableAfterApplyingFilters(true);
      } else {
        setMarketIsNotAvaiiableAfterApplyingFilters(false);
      }
    }
    setItems([]);
    setDiscoveryTabData(filteredData);
    setItems(filteredData.slice(0, 15));
    setOpenFilter(false);
  };

  const handleScoreCardHover = market => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    const id = setTimeout(() => {
      // setHoveredMarket(market);
      setTopPerformingMarketOnFocus(market);
    }, 500);
    setTimeoutId(id);
  };

  const handleScoreCardLeave = () => {
    if (timeoutId) {
      clearTimeout(timeoutId); // Clear timeout when user leaves the card
      setTimeoutId(null); // Reset timeout id
    }
    // setHoveredMarket(null); // Clear hovered card when user leaves
    setTopPerformingMarketOnFocus(null);
  };

  const handleFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setFilterAnchorEl(event.currentTarget);
    setOpenFilter(prev => !prev);
  };

  const handleActiveListingsChange = (event: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      setSelectedMarketTypeFromFilter('all');
      setActiveListingFilterRange(newValue as [number, number]);
    }
  };

  const handlePropertyPriceChange = (event: Event, newValue: number | number[]) => {
    if (Array.isArray(newValue)) {
      setSelectedMarketTypeFromFilter('all');
      setPropertyPriceFilterRange(newValue as [number, number]);
    }
  };

  const filterButtonStyle = {
    map: {
      position: 'absolute',
      zIndex: theme.zIndex.drawer - 1,
      top: 15,
      right: 0,
      minHeight: '35px',
      width: 'auto',
      background: COLOR_PRIMARY_2,
      color: '#fff',
      borderRadius: '4px',
      marginLeft: '-280px',
      marginRight: '10px',
      boxShadow: '0 4px 16px #0003',
      fontWeight: 'bold',
      '&:hover': {
        color: '#fff',
        background: COLOR_PRIMARY,
      },
    },
    dashboard: {
      height: '35px',
      background: COLOR_PRIMARY,
      color: '#fff',
      borderRadius: '4px',
      marginRight: '10px',
      '&:hover': {
        color: '#fff',
        background: COLOR_PRIMARY,
      },
    },
  };

  const DiscoveryFilter = (
    <>
      <Button
        sx={mapWidth === 100 ? filterButtonStyle.map : filterButtonStyle.dashboard}
        onClick={handleFilterClick}
      >
        <FilterListIcon />
        <Typography variant="body2" sx={{ paddingLeft: '5px' }}>
          {discoveryMarketType == 'top'
            ? matches
              ? 'Top Markets'
              : 'Top Markets 2024 By Airbtics'
            : 'Filters'}
        </Typography>
        <KeyboardArrowDownIcon />
      </Button>
      <Popper
        sx={{ zIndex: 2100 }}
        open={openFilter}
        anchorEl={filterAnchorEl}
        placement="bottom-end"
        transition
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={() => setOpenFilter(false)}>
            <Fade {...TransitionProps} timeout={350}>
              <Paper>
                <Grid
                  container
                  sx={{ width: 360, height: 535, padding: '10px', marginTop: '-80px' }}
                  gap={1}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      height: '40px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="h6">Filter</Typography>
                    <Button
                      sx={{
                        background: '#ffff',
                        color: COLOR_PRIMARY,
                        padding: '5px',
                        boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px',
                        borderRadius: '10px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        '&:hover': {
                          color: COLOR_PRIMARY,
                          background: '#ffff',
                        },
                      }}
                      onClick={() => {
                        setSelectedMarketTypeFromFilter('top');
                        resetFilterToDefault();
                      }}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                      <Typography variant="body2">Clear All</Typography>
                    </Button>
                  </Grid>
                  <Grid item xs={12} sx={{ height: '90px' }}>
                    <Box
                      sx={{
                        backgroundColor: COLOR_PRIMARY + '22',
                        padding: '10px',
                        borderRadius: '10px',
                      }}
                    >
                      <Typography>By Market Ranking</Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          backgroundColor: '#ffff',
                          height: '25px',
                          padding: '10px',
                        }}
                      >
                        <FormControl component="fieldset">
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={selectedMarketTypeFromFilter}
                            onChange={e => {
                              setSelectedMarketTypeFromFilter(e.target.value as 'top' | 'all');
                              if (e.target.value == 'all') {
                                setActiveListingFilterRange([
                                  minActiveListingsCount,
                                  maxActiveListingCount,
                                ]);
                                setPropertyPriceFilterRange([minPropertyPrice, maxPropertyPrice]);
                              } else {
                                resetFilterToDefault();
                              }
                            }}
                          >
                            <FormControlLabel
                              value="top"
                              control={
                                <Radio
                                  style={{
                                    color: COLOR_PRIMARY,
                                    padding: '0px',
                                    paddingLeft: '10px',
                                  }}
                                />
                              }
                              label={<span style={{ fontSize: '12px' }}>🏆Top Market 2024</span>}
                            />
                            <FormControlLabel
                              value="all"
                              control={
                                <Radio
                                  style={{
                                    color: COLOR_PRIMARY,
                                    padding: '0px',
                                    paddingLeft: '10px',
                                  }}
                                />
                              }
                              label={<span style={{ fontSize: '12px' }}>🌏All Markets</span>}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sx={{ height: '200px' }}>
                    <Grid
                      container
                      item
                      xs={12}
                      sx={{
                        backgroundColor: COLOR_PRIMARY + '22',
                        padding: '10px',
                        borderRadius: '10px',
                      }}
                    >
                      <Grid item xs={12}>
                        <Typography>By Market Metrics</Typography>
                      </Grid>
                      <Grid
                        container
                        item
                        xs={12}
                        sx={{
                          backgroundColor: '#ffff',
                          padding: '10px',
                          position: 'relative',
                        }}
                      >
                        <Typography variant="body2">🏡No of active Listings</Typography>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Slider
                            size="small"
                            value={activeListingFilterRange}
                            min={minActiveListingsCount}
                            max={maxActiveListingCount}
                            step={1000}
                            marks={[
                              {
                                value: minActiveListingsCount,
                                label: abbreviateNumber(minActiveListingsCount, false),
                              },
                              {
                                value: maxActiveListingCount,
                                label: abbreviateNumber(maxActiveListingCount, false),
                              },
                            ]}
                            onChange={handleActiveListingsChange}
                            valueLabelDisplay="auto"
                            valueLabelFormat={x => (x > 999 ? abbreviateNumber(x, false) : x)}
                            sx={{
                              color: COLOR_PRIMARY,
                              width: '80%',
                            }}
                          />
                        </Grid>

                        <Typography variant="body2">🛏️Median 1 bd Property Price</Typography>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Slider
                            size="small"
                            value={propertyPriceFilterRange}
                            min={minPropertyPrice}
                            max={maxPropertyPrice}
                            step={100000}
                            marks={[
                              {
                                value: minPropertyPrice,
                                label: `${exchangeRates[currency].symbol}${abbreviateNumber(
                                  convertCurrency(currency, minPropertyPrice),
                                  false
                                )}`,
                              },
                              {
                                value: maxPropertyPrice,
                                label: `${exchangeRates[currency].symbol}${abbreviateNumber(
                                  convertCurrency(currency, maxPropertyPrice),
                                  false
                                )}`,
                              },
                            ]}
                            onChange={handlePropertyPriceChange}
                            valueLabelDisplay="auto"
                            valueLabelFormat={x =>
                              x > 999
                                ? `${exchangeRates[currency].symbol}${abbreviateNumber(
                                    convertCurrency(currency, x)
                                  )}`
                                : x
                            }
                            sx={{
                              color: COLOR_PRIMARY,
                              width: '80%',
                            }}
                          />
                        </Grid>

                        {!isMarketDataAccessible && (
                          <div
                            style={{
                              height: '95%',
                              position: 'absolute',
                              width: '95%',
                              background: '#ffffff',
                              filter: 'blur( 6px)',
                              opacity: 0.8,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          ></div>
                        )}
                        {!isMarketDataAccessible && (
                          <Typography
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              fontSize: '26px',
                              fontWeight: 900,
                              color: COLOR_E,
                              transform: 'translate(-50%, -50%)',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleOnSampleClick('scale');
                            }}
                          >
                            PREMIUM
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ height: '120px' }}>
                    <Grid
                      container
                      item
                      xs={12}
                      sx={{
                        backgroundColor: COLOR_PRIMARY + '22',
                        padding: '10px',
                        borderRadius: '10px',
                      }}
                    >
                      <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
                        {' '}
                        By Geographic Location{' '}
                        <Chip
                          label="Coming Soon"
                          variant="outlined"
                          size="small"
                          sx={{
                            color: COLOR_WARNING,
                            borderColor: COLOR_WARNING,
                            marginLeft: '10px',
                          }}
                        />
                      </Typography>{' '}
                      <Grid
                        container
                        item
                        xs={12}
                        sx={{
                          marginTop: '5px',
                          backgroundColor: '#ffff',
                          position: 'relative',
                        }}
                      >
                        <Grid container spacing={2} sx={{ padding: '10px' }}>
                          <Grid item xs={6}>
                            <FormControl component="fieldset">
                              <RadioGroup
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value=""
                                onChange={e => {
                                  // handleNumberOfReviewsChange(e.target.value as number | 'all');
                                }}
                              >
                                <FormControlLabel
                                  value="beach"
                                  control={
                                    <Radio
                                      disabled
                                      style={{
                                        color: COLOR_PRIMARY,
                                        padding: '0px',
                                        paddingLeft: '10px',
                                      }}
                                    />
                                  }
                                  label={<span style={{ fontSize: '12px' }}>🏖️ Beachfont</span>}
                                />
                                <FormControlLabel
                                  value="mountain"
                                  control={
                                    <Radio
                                      disabled
                                      style={{
                                        color: COLOR_PRIMARY,
                                        padding: '0px',
                                        paddingLeft: '10px',
                                      }}
                                    />
                                  }
                                  label={<span style={{ fontSize: '12px' }}>🏔️ Mountainous</span>}
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                          <Grid item xs={6}>
                            <FormControl component="fieldset">
                              <RadioGroup
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value=""
                                onChange={e => {
                                  // handleNumberOfReviewsChange(e.target.value as number | 'all');
                                }}
                              >
                                <FormControlLabel
                                  value="urban"
                                  control={
                                    <Radio
                                      disabled
                                      style={{
                                        color: COLOR_PRIMARY,
                                        padding: '0px',
                                        paddingLeft: '10px',
                                      }}
                                    />
                                  }
                                  label={<span style={{ fontSize: '12px' }}>📊 Urban</span>}
                                />
                                <FormControlLabel
                                  value="suburban"
                                  control={
                                    <Radio
                                      disabled
                                      style={{
                                        color: COLOR_PRIMARY,
                                        padding: '0px',
                                        paddingLeft: '10px',
                                      }}
                                    />
                                  }
                                  label={<span style={{ fontSize: '12px' }}>🏡 Suburban</span>}
                                />
                              </RadioGroup>
                            </FormControl>
                          </Grid>
                        </Grid>
                        {!isMarketDataAccessible && (
                          <div
                            style={{
                              height: '100%',
                              position: 'absolute',
                              width: '100%',
                              background: '#ffffff',
                              filter: 'blur( 6px)',
                              opacity: 0.8,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          ></div>
                        )}
                        {!isMarketDataAccessible && (
                          <Typography
                            sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              fontSize: '26px',
                              fontWeight: 900,
                              color: COLOR_E,
                              transform: 'translate(-50%, -50%)',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleOnSampleClick('scale');
                            }}
                          >
                            PREMIUM
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sx={{ height: '90px' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Button
                        sx={{
                          background: COLOR_PRIMARY,
                          color: '#fff',
                          borderRadius: '4px',
                          marginRight: '10px',
                          '&:hover': {
                            color: '#fff',
                            background: COLOR_PRIMARY,
                          },
                        }}
                        onClick={() => {
                          handleApplyFilter();
                          setIsFilterApplied(true);
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <DoneIcon /> APPLY
                        </Typography>
                      </Button>

                      <Button
                        sx={{
                          background: COLOR_BACKGROUND_1,
                          color: COLOR_PRIMARY,
                          borderRadius: '4px',
                          '&:hover': {
                            color: COLOR_PRIMARY,
                            background: COLOR_BACKGROUND_1,
                          },
                        }}
                        onClick={() => {
                          setOpenFilter(false);
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <CloseIcon /> CANCEL
                        </Typography>
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );

  const SearchCountryOption = (isMap: boolean = false) => (
    <FormControl variant="standard" sx={{ m: 0, minWidth: 120 }}>
      <Select
        disableUnderline={isMap ? true : false}
        value={AVAILABLE_COUNTRY[selectedDiscoveryCountry]}
        onChange={event => {
          if (!Object.keys(AVAILABLE_COUNTRY).includes(event.target.value)) {
            redirectToAdvancedExplorerTab();
            return;
          }
          const countryCodeSelected = event.target.value;
          if (countryCodeSelected == selectedDiscoveryCountry) return;
          setSelectedDiscoveryCountry(countryCodeSelected);
          window.history.pushState('', '', '/markets/' + countryCodeSelected);
        }}
        MenuProps={
          isMap
            ? {
                sx: {
                  marginTop: '-60px',
                },
                autoFocus: false,
              }
            : {
                autoFocus: false,
              }
        }
        sx={{
          fontWeight: 500,
          paddingTop: 0,
          '& #demo-simple-select-standard': {
            paddingTop: '0px !important',
            paddingLeft: '5px',
          },
          '& .MuiSelect-standard': {
            paddingTop: '0px !important',
            backgroundColor: 'transparent',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: isMap ? 'none' : 'auto',
            outline: 'none',
          },
          fieldset: {
            border: 'none !important',
            outline: 'none',
          },
        }}
        renderValue={selected => (
          <Typography
            variant={matches ? 'body2' : isMap ? 'body1' : 'h5'}
            sx={{ fontWeight: 500, color: COLOR_PRIMARY }}
          >
            {selected}
          </Typography>
        )}
      >
        {Object.keys(ALL_COUNTRY).map(countryCode => (
          <MenuItem value={countryCode}>{ALL_COUNTRY[countryCode]}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  const isSearchingInputRef = useRef<HTMLInputElement>(null);
  const [countrySearching, setCountrySearching] = useState<string | null>(null);

  const SearchCountryOptionInMap = (
    <Portal container={() => document.getElementById('map')!}>
      <Box
        id="portalOption"
        sx={{
          position: 'absolute',
          zIndex: 99990,
          bottom: '20px',
          right: '50%',
          padding: '5px 20px',
          backgroundColor: '#fff',
          borderRadius: '900px',
          transform: 'translateX(50%)',
          boxShadow: '0 4px 10px #0004',
          width: 'max(320px, min(400px, 100vw))',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
        }}
      >
        <Autocomplete
          disablePortal
          id="country Search"
          value={countrySearching}
          onInputChange={(e, value) => setCountrySearching(value)}
          options={Object.keys(ALL_COUNTRY).map(countryCode => ALL_COUNTRY[countryCode])}
          renderInput={(params: AutocompleteRenderInputParams) => (
            <TextField
              {...params}
              size="small"
              inputRef={isSearchingInputRef}
              label={params.inputProps.value ? '' : 'Discover markets in a specific country...'}
              InputLabelProps={{
                shrink: false,
                style: { paddingLeft: '20px', color: COLOR_GREY_400 },
              }}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start" sx={{ color: COLOR_PRIMARY }}>
                    <SearchIcon />
                  </InputAdornment>
                ),
                sx: {
                  color: COLOR_TEXT_4,
                  backgroundColor: '#fff',
                  borderRadius: 4,
                  padding: '0px 0px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none !important',
                  },
                },
              }}
              sx={{
                '& .MuiInputLabel-root.Mui-focused': {
                  opacity: '0 !important', // Hide on focus
                },
              }}
            />
          )}
          onChange={(event, value) => {
            if (!value || value == '') {
              return;
            }
            if (!Object.keys(AVAILABLE_COUNTRY).includes(value)) {
              redirectToAdvancedExplorerTab();
              return;
            }

            const countryCode = Object.keys(AVAILABLE_COUNTRY).find(
              key => AVAILABLE_COUNTRY[key] == value
            ) as string;
            setSelectedDiscoveryCountry(countryCode);
            window.history.pushState('', '', '/markets/' + countryCode);

            setCountrySearching(_ => null);

            if (isSearchingInputRef && isSearchingInputRef.current) {
              isSearchingInputRef.current.blur();
            }
          }}
          sx={{
            width: '100%',
          }}
        />
      </Box>
    </Portal>
  );

  return (
    <>
      {isDiscoveryMarketLoading && !marketIsNotAvaiiableAfterApplyingFilters && (
        <Box
          sx={{
            height: isDiscoveryMapViewOpen ? '20vh' : '70vh',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ContinuousSpinner />
        </Box>
      )}
      {((items.length > 0 && !isDiscoveryMarketLoading) ||
        marketIsNotAvaiiableAfterApplyingFilters) && (
        <>
          <Box sx={{ height: '100vh', width: '100%' }}>
            <Grid sx={{ marginTop: '10px' }}>
              <Alert severity="info">
                <Typography
                  component="a"
                  onClick={() => {
                    handleOnSampleClick('scale');
                  }}
                  sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {SCALE_CTA}
                </Typography>{' '}
                to unlock more insights and data.
              </Alert>
            </Grid>
            <InfiniteScroll
              dataLength={items.length}
              next={fetchMoreData}
              hasMore={items.length < discoverTabData.length}
              loader={<CircularProgress />}
              height={'100vh'}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: '20px',
                  marginBottom: '20px',
                  backgroundColor: '#ffff',
                  zIndex: theme.zIndex.drawer - 1,
                }}
              >
                <Typography
                  variant={matches ? 'body2' : 'h5'}
                  sx={{ fontWeight: 500, padding: '10px 0px 10px 30px', display: 'block' }}
                >
                  Discover top markets across{' '}
                  {discoveryMarkets ? discoveryMarkets.length > 0 && SearchCountryOption() : ''}
                </Typography>
                <CustomSwitch active={active} setActive={setActive} />
                {/* {DiscoveryFilter} */}
              </Box>
              {marketIsNotAvaiiableAfterApplyingFilters && (
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <Alert severity="warning" sx={{ width: '90%' }}>
                    No Market Availiable.
                  </Alert>
                </Box>
              )}
              <Grid container spacing={2} sx={{ paddingLeft: matches ? '15px' : '30px' }}>
                {items.map((market, index) => (
                  <Grid item key={index}>
                    <ScoreCard
                      district={market.district}
                      countryCode={market.country_code}
                      country={market.country}
                      score={market.ten_years_roi}
                      propertyPrice={market.property_price}
                      propertyPriceAppreciation={market.property_price_change}
                      populationGrowth={market.population_change}
                      medianHouseholdIncomeGrowth={market.income_change}
                      grossRentalYield={market.net_rental_yield}
                      city={market.city}
                      market={market}
                      onMouseEnter={handleScoreCardHover}
                      onMouseLeave={handleScoreCardLeave}
                      marketsToCompareList={marketsToCompareList}
                      setMarketsToCompareList={setMarketsToCompareList}
                      minROI={minROI}
                      maxROI={maxROI}
                      revenue={market.revenue}
                      currency={currency}
                      annualAppreciation={market.annual_appreciation}
                      isMarketDataAccessible={isMarketDataAccessible}
                      freeMarketDataKey={freeMarketDataKey}
                      matches={matches}
                      handleOnSampleClick={handleOnSampleClick}
                      marketGeoType={market.geo_type ? market.geo_type : null}
                      marketLength={allRawMarketData ? allRawMarketData.length : 0}
                      isFromDiscoveryAi={false}
                      setSelectedMarketInDiscoveryAI={() => {}}
                    />
                  </Grid>
                ))}
              </Grid>
            </InfiniteScroll>

            {!matches && marketsToCompareList.length > 0 && (
              <Box
                sx={{
                  height: showCompareDrawer ? '110px' : '0px',
                  width: matches ? '100%' : '75%',
                  backgroundColor: COLOR_TEXT_1 + '99',
                  position: 'absolute',
                  bottom: '0px',
                  right: '0px',
                  margin: matches ? '0px' : '0px 30px',
                  padding: showCompareDrawer ? '10px' : '0px',
                  borderRadius: matches ? '20px 0px 0px 0px' : '20px 20px 0px 0px',
                  transition: 'height 0.3s ease-in-out',
                  zIndex: 10000000,
                }}
              >
                <Box
                  sx={{
                    backgroundColor: COLOR_TEXT_1 + '99',
                    height: '30px',
                    width: matches ? '160px' : '200px',
                    position: 'absolute',
                    top: '-40px',
                    padding: '5px',
                    right: matches ? '0px' : '20px',
                    borderRadius: '10px 10px 0px 0px',
                    '&:hover': {
                      cursor: 'pointer',
                    },
                  }}
                  onClick={() => {
                    setShowCompareDrawer(!showCompareDrawer);
                  }}
                >
                  {' '}
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#ffff',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {showCompareDrawer ? 'Hide Comparision' : 'Show Comparison'}
                    {showCompareDrawer ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
                  </Typography>
                </Box>
                <Grid container sx={{ height: '100%', padding: '5px' }}>
                  <Grid
                    container
                    xs={9}
                    sx={{
                      overflowX: matches ? 'auto' : 'visible',
                      overflowY: matches ? 'clip' : 'visible',
                      width: '100%',
                      display: 'flex',
                      flexWrap: 'nowrap',
                      '&::-webkit-scrollbar': {
                        width: '10px',
                      },
                      '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '5px',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                        background: '#555',
                      },
                    }}
                  >
                    {marketsToCompareList.map(market => (
                      <Grid
                        item
                        key={market[0]}
                        xs={3}
                        sx={{ minWidth: '100px', flex: '0 0 auto' }}
                      >
                        <Box
                          sx={{
                            height: '95%',
                            width: '95%',
                            margin: '5px',
                            background: '#ffff',
                            border: '2px solid #ffff',
                            borderRadius: '5px',
                            position: 'relative',
                          }}
                        >
                          <Box
                            sx={{
                              position: 'absolute',
                              top: '0',
                              right: '0',
                              display: 'flex',
                              justifyContent: 'flex-end',
                              '&:hover': {
                                cursor: 'pointer',
                              },
                            }}
                            onClick={() => {
                              setMarketsToCompareList(_ =>
                                [...marketsToCompareList].filter(
                                  currentMarket => currentMarket[0] !== market[0]
                                )
                              );
                            }}
                          >
                            <CloseIcon sx={{ padding: 0 }} />
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              width: '100%',
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 500, textAlign: 'center' }}
                            >
                              {market[0]}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                    {marketsToCompareList.length < 4 &&
                      [...Array(4 - marketsToCompareList.length)].map((_, index) => (
                        <Grid
                          item
                          key={index + marketsToCompareList.length}
                          xs={3}
                          sx={{ minWidth: '100px', flex: '0 0 auto' }}
                        >
                          <Box
                            sx={{
                              height: '95%',
                              width: '95%',
                              margin: '5px',
                              backgroundColor: COLOR_TEXT_1 + '99',
                              borderRadius: '5px',
                              border: '2px solid #ffff',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                padding: '5px',
                                textAlign: 'center',
                                color: '#ffff',
                              }}
                            >
                              Select more to compare
                            </Typography>
                          </Box>
                        </Grid>
                      ))}
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      gap: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: COLOR_SUCCESS,
                        '&:hover': { backgroundColor: COLOR_SUCCESS_1 },
                        borderRadius: '20px',
                        width: matches ? '70%' : '90%',
                      }}
                      onClick={() => {
                        setDashboardLayoutView('compare');
                        setSelectedSidebarIndex(3);
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 500,
                          color: '#ffff',
                          fontSize: matches ? '12px' : '14px',
                        }}
                      >
                        Compare
                      </Typography>
                    </Button>
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: COLOR_SUCCESS,
                        '&:hover': { borderColor: COLOR_SUCCESS_1 },
                        borderRadius: '20px',
                        width: isMobile ? '70%' : '90%',
                      }}
                      onClick={() => {
                        setMarketsToCompareList([]);
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 500,
                          color: '#ffff',
                          fontSize: matches ? '12px' : '14px',
                        }}
                      >
                        Clear selection
                      </Typography>
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        </>
      )}
      {matches && (
        <Box
          sx={{
            height: '30px',
            width: '100px',
            backgroundColor: '#000',
            position: 'absolute',
            bottom: '0px',
            left: '0px',
            borderRadius: '0px 10px 0px 0px',
            padding: '5px 0px 5px 20px',
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.5)',
            '&:hover': {
              cursor: 'pointer',
            },
          }}
          onClick={() => {
            if (isDiscoveryMapViewOpen) {
              setIsDiscoveryMapViewOpen(false);
              setMapWidth(0);
            } else {
              setIsDiscoveryMapViewOpen(true);
              setMapWidth(100);
            }
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500, color: '#ffff' }}>
            {isDiscoveryMapViewOpen ? 'View List' : 'View Map'}
          </Typography>
        </Box>
      )}

      {matches && (
        <Box
          sx={{
            height: '30px',
            width: '100px',
            backgroundColor: '#000',
            position: 'absolute',
            bottom: '0px',
            right: '0px',
            borderRadius: '10px 0px 0px 0px',
            padding: '5px 0px 5px 20px',
            boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.5)',
            '&:hover': {
              cursor: 'pointer',
            },
          }}
          onClick={() => {
            setMapWidth(0);
            setDashboardLayoutView('compare');
            setSelectedSidebarIndex(3);
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500, color: '#ffff' }}>
            {'Compare'}
          </Typography>
        </Box>
      )}

      {mapWidth === 100 && !matches && SearchCountryOptionInMap}

      {isDiscoveryMarketLoading && mapWidth === 100 && (
        <Portal container={() => document.getElementById('map')!}>
          <Box
            sx={{
              width: '300px',
              height: '300px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              borderRadius: '12px',
              background: '#fff5',
            }}
          >
            <ContinuousSpinner />
          </Box>
        </Portal>
      )}
    </>
  );
};

export default React.memo(DiscoveryTab);
